module.exports = __webpack_public_path__ + "static/img/home2.947b1bb0.png";